
import React, { useState } from 'react';
import { Button, Form, Alert,Row, Col, Container, Card} from 'react-bootstrap';
import axios from 'axios';
import { Link } from 'react-router-dom';
import { RenderHeader } from '../_components/Header';
import { NavbarSmart } from '../_components/NavbarSmart';

function Signup() {

  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [signupSuccess, setSignupSuccess] = useState(false)
  const [existingUser, setExistingUser] = useState(false)
  const [signupFailed, setSignupFailed] = useState(false)
  const [submitting, setSubmitting] = useState(false)

  // functions 
  async function handleSignup(e) {
    
    setSubmitting(true);
    setSignupFailed(false)
    setExistingUser(false)

    var submitValue = { 
      email: email, 
      password: password
    };
    
    try {
      const response = await axios.post(process.env.REACT_APP_BASE_URL + 'jobs/auth/signup', submitValue)
      .then( (response) => {
        let data = response.data;
        if (data.status === 'ok'){
          console.log('ok')
          setSignupSuccess(true)
          
        } else if (data.status === 'ALREADY_EXISTS') {
          setExistingUser(true);
          console.log('already exists')
        } else {
          setSignupFailed(true);
          console.log('something went wrong')
        }

      });


    } catch (error) {
      console.error('Signup failed:', error);
    }

    setSubmitting(false);
  }

  return (
    <>
      
      <RenderHeader />
      <NavbarSmart />

      {/* // show this if they don't yet have a successful sign up attempt */}
      { !signupSuccess && 
      <Container>
        <Row>
          <Col>
            <br/>
            <Card style={{textAlign: "center"}}>
              <Card.Title><br/>Signup</Card.Title>
              <Card.Body>
                Why do I make folks sign up?  The short version is to keep bots and cralwers from scraping my jobs.  Your email is <b>never</b> sold or given to anyone.  This site is always free <b>to people</b>.  Just not bots. :-)
                <br/>
                <br/>
                <Form>
                  {signupFailed ? <Alert>Something went wrong, try again</Alert> : <div></div>}
                  {existingUser ? <Alert>Looks like you already registered, click <Link to="/login">here</Link> to sign in.</Alert> : <div></div>}
                  <Form.Group controlId="formBasicEmail">
                    <Form.Label>Email</Form.Label>
                    <Form.Control
                      type="text"
                      placeholder="Enter email"
                      value={email}
                      onChange={(e) => setEmail(e.target.value)}
                    />
                  </Form.Group>

                  <Form.Group controlId="formBasicPassword">
                    <Form.Label>Password</Form.Label>
                    <Form.Control
                      type="password"
                      placeholder="Password"
                      value={password}
                      onChange={(e) => setPassword(e.target.value)}
                    />
                  </Form.Group>
                  <br/>
                  <Button variant="primary" onClick={handleSignup}>
                  {submitting ? 'Submitting...' : 'Save'}
                  </Button>
                </Form>
              </Card.Body>

            </Card>
          </Col>
        </Row>
      </Container>
      }

      {/* // show this on successful signup */}
      { signupSuccess && 
      <Container>
        <Row>
          <Col>
            <br/>
            <Card style={{textAlign: "center"}}>
              <Card.Title><br/>Signup</Card.Title>
              <Card.Body>
                All set! :-)
                <br/>
                <br/>
                <Button variant="primary" href="/login">Click here to log in and start browsing jobs.</Button>
              </Card.Body>

            </Card>
          </Col>
        </Row>
      </Container>
      }
    </>
  );

}

export default Signup;